module.exports = __webpack_public_path__ + "static/media/gallery-14.ce2d21cd.jpg";